module.exports = __webpack_public_path__ + "img/tui-2.7dac6278.png";